var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEquals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 8
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-equals_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.148268 0 0 0 0 0.148268 0 0 0 0 0.148268 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-equals_svg__b"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.148268 0 0 0 0 0.148268 0 0 0 0 0.148268 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-equals_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-equals_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M0 0h16v1H0zm0 7h16v1H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgMTYgOCI+CiAgICA8ZGVmcz4KICAgICAgICA8ZmlsdGVyIGlkPSJ6Y2tjN3d5MXZhIj4KICAgICAgICAgICAgPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUdyYXBoaWMiIHZhbHVlcz0iMCAwIDAgMCAwLjE0ODI2OCAwIDAgMCAwIDAuMTQ4MjY4IDAgMCAwIDAgMC4xNDgyNjggMCAwIDAgMS4wMDAwMDAgMCIvPgogICAgICAgIDwvZmlsdGVyPgogICAgICAgIDxmaWx0ZXIgaWQ9ImRsdnlqdGVtOGIiPgogICAgICAgICAgICA8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlR3JhcGhpYyIgdmFsdWVzPSIwIDAgMCAwIDAuMTQ4MjY4IDAgMCAwIDAgMC4xNDgyNjggMCAwIDAgMCAwLjE0ODI2OCAwIDAgMCAxLjAwMDAwMCAwIi8+CiAgICAgICAgPC9maWx0ZXI+CiAgICA8L2RlZnM+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnPgogICAgICAgICAgICA8ZyBmaWx0ZXI9InVybCgjemNrYzd3eTF2YSkiPgogICAgICAgICAgICAgICAgPGcgZmlsdGVyPSJ1cmwoI2RsdnlqdGVtOGIpIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjRjNGM0YzIiBkPSJNMCAwSDE2VjFIMHpNMCA3SDE2VjhIMHoiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIconEquals as ReactComponent };